import { Injectable, EventEmitter, OnDestroy, WritableSignal, signal } from '@angular/core';
import { Point } from './shared/point';
import { TranslateService } from '@ngx-translate/core';
import { SmService } from 'supermappe-core';
import { ApiService } from './core/api/api.service';
import { Subscription } from 'rxjs';
import { QuickEditService } from './shared/commands/quick-edit.service';
import { AuthenticationService } from './core/authentication/authentication.service';
import { CookieService } from 'ngx-cookie-service';
import { MathContentMessage } from '../../../commondata/messages/messages-dto';
import { InitialStateDto } from '../../../commondata/messages/initial-state-dto';
import { CustomSelectElement } from './shared/custom-select-element-dto';
import { UiConstants } from './shared/ui-constants';
import { SelectionDataDto } from '../../../commondata/messages/selection-data-dto';
import { ImageDataDto } from '../../../commondata/messages/image-data-dto';
import { SpeakerDto } from '../../../commondata/messages/speaker-dto';
import { StatDto } from './core/stats/stat-dto';
import { TLInteractionDto } from '../../../commondata/messages/tl-interaction-dto';

@Injectable({
    providedIn: 'root'
})
export class ModuleStateService implements OnDestroy {

    public guid: string = '';
    public docId = '';
    public gooogleId: string = '';
    // public docId: string = '';
    public sideDocInfo: any = { sideDocId: '', sideDocType: '', sideDocName: '' }

    public DEFAULT_LIMIT_PRINT_SIZE = 5000;
    private _limitPrintSize: number = this.DEFAULT_LIMIT_PRINT_SIZE;

    public get limitPrintSize() {
        return this._limitPrintSize;
    }
    public set limitPrintSize(value: number) {
        this._limitPrintSize = value;
        const lps: string = value + '';
        localStorage.setItem('limitPrintSize', lps);
    }

    public PRINT_QUALITY_SIZES = [1000, 2000, 3000, 4000, 5000];

    private _googleUri = '';
    get googleUri(): string {
        return this._googleUri;
    }
    set googleUri(googleUri: string) {
        this._googleUri = googleUri;
        this.onGoogleUriChange.emit(this.googleUri);
    }

    private _isMine = false;
    get isMine(): boolean {
        return this._isMine;
    }
    set isMine(isMine: boolean) {
        this._isMine = isMine;
        this.onMapIsMine.emit(this.isMine);
    }

    public COPY_TYPE = {
        ALL: 'all',
        TEXT: 'text',
        DEEP: 'deep',
        IMAGE: 'image'
    };

    public viewMode = true; // serve per capire se è in visualizzazione o in edit
    public readOnly = false;
    public googleFileId = '';
    public isShared = false;
    public fileRef: any;
    private isBusy = false;
    private isEditing = false;
    private _isFormatCopying = false;
    public isLocked = false;
    public workJson: any;
    public name = '';
    public googleId = '';
    public author = '';
    public isNew = false;
    public startText: string = '';
    public canvasOrigin: Point | undefined;
    public canvasBottomRight: Point | undefined;
    public editOnText = false;
    private autoSaving = false;
    public lastSaveIndex = -1;
    public index = -1;
    public _isDirty = false;
    public error = '';
    public mapPreview: any;
    public mapLanguage = '';
    public selectionData: any;
    public canEnableQuickEdit = false;
    public isLoaded = false;
    public isShowExiting = false;
    public forceExit = false;
    public dropping = false;
    public isCopyingMapImage = false;
    private isFocusOnMap = false;
    public docFileId = '';
    public isSomeOperationStarted = false;
    public gcShareMapId = '';
    public copyType = '';
    public pasteMode = '';
    public hasDeepContent = false;
    public pasteWithDeepContent = false;
    public currentRecentGroup = 'all';
    public mapOperations: Array<StatDto> = [];
    public docLanguage: string;
    public speakers: SpeakerDto[] = [];
    public selectedLanguage: string = '';
    public selectedSpeakerName: string = '';
    public isEditShowMode = false;

    public onSetInitialState = new EventEmitter<InitialStateDto>();
    public onMapIsMine = new EventEmitter<boolean>();
    public onShareData = new EventEmitter<any>();
    public onExportChange = new EventEmitter<any>();
    public onGoogleUriChange = new EventEmitter<string>();
    public startSharing = new EventEmitter<any>();
    public stopSharing = new EventEmitter<string>();
    public onCanEnableQuickEditChange = new EventEmitter<boolean>();
    public onBusyStateChange = new EventEmitter<any>();
    public onAutoSavingChange = new EventEmitter<any>();
    public onEditingChange = new EventEmitter<any>();
    public onError = new EventEmitter<any>();
    public onLoaded = new EventEmitter<boolean>();
    public onDirtyStateChange = new EventEmitter<boolean>();
    public onSaveStatusChange = new EventEmitter<number>();
    public onForceAutosave = new EventEmitter<any>();
    public onChangedBackColor = new EventEmitter<any>();
    public onChangePasteState = new EventEmitter<boolean>();
    public onStartEditImage = new EventEmitter<any>();
    public onCopyFormatStateChange = new EventEmitter<boolean>();
    public onChangeDocName = new EventEmitter<string>();
    public onEventUser = new EventEmitter<any>();
    public refreshRecentSharing = new EventEmitter<string>();
    public onUserIsDemo = new EventEmitter<boolean>();
    public onGridChange = new EventEmitter<boolean>();
    public onClearMathErrors = new EventEmitter();
    public onMapGetFocus = new EventEmitter<boolean>();
    public onImageLoaded = new EventEmitter();
    public onChooseFileDrive = new EventEmitter<string>();
    public onMathContent = new EventEmitter<MathContentMessage>();
    public onMathOpen = new EventEmitter<boolean>();
    public onTalkingStart = new EventEmitter();
    public onTalkingEnd = new EventEmitter();
    public onDocLanguageChanged = new EventEmitter<string>();
    public onLanguageChangedFromShell = new EventEmitter<string>();
    public onSearchSelection = new EventEmitter<string>();
    public onCopySideSelection = new EventEmitter();
    public onPasteSideSelection = new EventEmitter<SelectionDataDto>();
    public onImageInsert = new EventEmitter<ImageDataDto>();
    public onRequestCrop = new EventEmitter<void>();
    public onBeforeExit = new EventEmitter<boolean>();
    public onAttachDocument = new EventEmitter<string>();
    public onAttachNewDocument = new EventEmitter<any>();
    public onImageMapRequest = new EventEmitter();
    public onImageMapInsert = new EventEmitter<string>();
    public onMapFragmentCopied = new EventEmitter<any>();
    public onChangeEditShow = new EventEmitter<any>(); //undoData on readorderEdit
    public onTLInteraction = new EventEmitter<TLInteractionDto>();

    private uploadWorkJsonSubscription: Subscription | undefined;
    private renameDocSubscription: Subscription | undefined;

    public isGridVisible = false;
    public shellHost: string = '';

    public isDeactivateDialogOpen: boolean = false;

    get isDirty() {
        return this._isDirty;
    }
    set isDirty(value: boolean) {
        this._isDirty = value;
        this.onDirtyStateChange.next(value);
    }

    public guiLanguage: string = '';

    private _ttsEnabled: boolean = false;
    get ttsEnabled(): boolean {
        return this._ttsEnabled;
    }
    set ttsEnabled(value: boolean) {
        this._ttsEnabled = value;
        if (this.smService.isTTSEnabled() !== value) {
            this.smService.toggleTTS()
        }
    }

    public voices: Array<SpeechSynthesisVoice> = [];
    private _languages: CustomSelectElement[] = [];
    public get languages(): CustomSelectElement[] {
        return this._languages;
    }
    public set languages(value: CustomSelectElement[]) {
        this._languages = value;
        this.sortLanguages();
    }
    public languagesWithFlag: CustomSelectElement[] = [];
    public languagesNoFlag: CustomSelectElement[] = [];

    private _isLockedbyUser: boolean = false;
    get isLockedbyUser() {
        return this._isLockedbyUser;
    }
    set isLockedbyUser(value: boolean) {
        this._isLockedbyUser = value;
    }
    private _saveStatus: number = 0;

    get saveStatus(): number {
        return this._saveStatus;
    }
    set saveStatus(value: number) {
        this._saveStatus = value;
        this.onSaveStatusChange.next(value);
    }

    public isClaireEnabledInConfig: WritableSignal<boolean> = signal(false);

    constructor(
        private translateService: TranslateService,
        private smService: SmService,
        private apiService: ApiService,
        private authenticationService: AuthenticationService,
        private quickEditService: QuickEditService,
        private cookieService: CookieService
    ) {
        this.docLanguage = this.translateService.currentLang;
        this.initialize();
    }

    ngOnDestroy(): void {
        if (this.uploadWorkJsonSubscription) { this.uploadWorkJsonSubscription.unsubscribe(); }
        if (this.renameDocSubscription) { this.renameDocSubscription.unsubscribe(); }
    }

    public initialize() {
        // this.guid = Guid.create().toString();
        // this.docLanguage = this.translateService.currentLang;
        this.isShared = false;
        this.copyType = this.COPY_TYPE.ALL;
        this.mapOperations = [];
        this.setLoaded(false);
        this.canvasOrigin = new Point(0, 0);
        this.editOnText = false;
        this.lastSaveIndex = -1;
        this.index = -1;
        this.isDirty = false;
        this.isNew = false;
        this.error = '';
        this.mapLanguage = '';
        this.selectionData = '';
        this.forceExit = false;
        this.dropping = false;
        this.isCopyingMapImage = false;
        this.setCanEnableQuickEdit(true);
        this.setFocusOnMap(true);
        const storedLpss = localStorage.getItem('limitPrintSize');
        const lpss: string = (storedLpss ? storedLpss : '');
        const lps: number = parseInt(lpss, 10);
        if (lps >= 1000) { // PRINTSIZE (at least 1000px!!!)
            this._limitPrintSize = lps;
        }
    }

    public resetPasteState(value: boolean) {
        this.onChangePasteState.emit(value);
    }

    public clear() {
        this.initialize();
    }

    public EditImage() {
        this.onStartEditImage.emit();
    }

    public lockUI(locked: boolean, busy?: boolean) {
        this.isLocked = locked;
        this.setEditingState(locked);
        this.setCanEnableQuickEdit(!locked);
        this.smService.setEnableKeyPresses(!locked);
        this.setBusyState((busy ? busy : false));
    }

    public setFocusOnMap(mapHasFocus: boolean) {

        if (this.isFocusOnMap !== mapHasFocus) {
            this.isFocusOnMap = mapHasFocus;


            this.smService.setEnableKeyPresses(mapHasFocus);
            if (!mapHasFocus) {
                this.quickEditService.disableAll();
            }
            this.onMapGetFocus.emit(mapHasFocus);
        }
        // if (mapHasFocus) {
        //     this.smService.setEnableKeyPresses(true);
        // }


    }

    public getFocusOnMap(): boolean {
        return this.isFocusOnMap;
    }

    public forceAutoSave() {
        this.onForceAutosave.next('');
    }

    public setLoaded(value: boolean) {
        this.isLoaded = value;
        this.onLoaded.next(value);
    }

    public setBusyState(value: boolean) {
        this.isBusy = value;
        this.onBusyStateChange.next(value);
    }

    public getBusyState(): boolean {
        return this.isBusy;
    }

    public setAutosaving(value?: boolean) {
        this.autoSaving = (value ? value : false);
        this.onAutoSavingChange.next(value);
    }

    public getAutosaving(): boolean {
        return this.autoSaving;
    }

    public setEditingState(value?: boolean) {
        this.isEditing = (value ? value : false);
        this.onEditingChange.next(value);
    }

    public getEditingState() {
        return this.isEditing;
    }

    public setStateError(err: string) {
        this.error = err;
        this.onError.next(err);
    }

    public setCanEnableQuickEdit(value: boolean) {
        this.canEnableQuickEdit = value;
        this.onCanEnableQuickEditChange.emit(value);
    }

    public setBackgroundColor(value: string) {
        if (value) {
            const oldColor = this.smService.getBackgroundColor();
            if (oldColor !== value) {
                this.smService.setBackgroundColor(value);
                this.onChangedBackColor.emit(value);
            }
        }
    }

    public autoRenameNewMap(mapName: string) {
        if (this.isNew && this.name === this.translateService.instant('NEW_MAP') && mapName.trim() !== '') {
            // Avoid rename on a link
            if (!mapName.startsWith('http://') && !mapName.startsWith('https://')) {
                this.name = mapName;
                if (mapName.length > 25) {
                    this.name = mapName.substr(0, 25);
                }
                this.workJson = this.smService.setMapName(this.name);
                this.isDirty = true;
                this.apiService.findOwnerEmailByDocId(this.docId).subscribe((result: any) => {
                    const ownerId = result.ownerId;
                    if (this.uploadWorkJsonSubscription) { this.uploadWorkJsonSubscription.unsubscribe(); }
                    this.uploadWorkJsonSubscription = this.apiService.uploadWorkJson(this.docId, this.workJson).subscribe(() => {
                        // this.isDirty = false;
                        console.log(`Auto renamed map to ${this.name}`);
                    });
                });
                if (this.renameDocSubscription) { this.renameDocSubscription.unsubscribe(); }
                this.renameDocSubscription = this.apiService.renameDoc(this.docId, this.name).subscribe(() => {
                });
                this.onChangeDocName.next(this.name);
            }
        }
    }

    public emitUserEvent(event: any) {
        this.onEventUser.emit(event);
    }

    private getClearText(strSrc: string) {
        let s = strSrc;
        s = s.replace(/\<br \/>/g, '\n');
        s = s.replace(/\<br\/>/g, '\n');
        s = s.replace(/&nbsp;/g, '');
        s = s.replace(/<[^<|>]+?>/gi, '');
        const txt = document.createElement("textarea");
        txt.innerHTML = s;
        s = txt.value;
        return s;
    }

    public getPlainText(HtmlText: string): string {
        return this.getClearText(HtmlText); //.trim();
    }

    public setPrintQuality(level: number) {
        if (level >= 0 && level < this.PRINT_QUALITY_SIZES.length) {
            this.limitPrintSize = this.PRINT_QUALITY_SIZES[level];
        }
    }

    public getPrintQuality() {
        let level = 5;
        let found = false;
        let i = 0;
        while (!found && i < this.PRINT_QUALITY_SIZES.length) {
            if (this.PRINT_QUALITY_SIZES[i] >= this.limitPrintSize) {
                level = i;
                found = true;
            } else {
                i++;
            }
        }
        return level;
    }

    public set isFormatCopying(value: boolean) {
        this._isFormatCopying = value;
        this.onCopyFormatStateChange.emit(value);
    }

    public get isFormatCopying() {
        return this._isFormatCopying;
    }

    public setCopyType(type: string) {
        this.copyType = type;
        // Fallback to ALL (Ctrl-C does not set type)
        setTimeout(() => {
            this.copyType = this.COPY_TYPE.ALL;
        }, 200);
    }

    public goToWebsiteClick(from: string, type: string) {
        if (type === 'private') {
            if (from === 'order-list') {
                // order-list
                // console.log('+++++https://www.anastasis.it/supermappex-privati');
                window.open('https://www.anastasis.it/smx-studio/', '_blank');
            } else if (from === 'invalid-credentials') {
                // invalid-credentials
                // console.log('+++++https://www.anastasis.it/supermappex-privati-info');
                window.open('https://www.anastasis.it/smx-studio/', '_blank');
            }
        } else if (type === 'school') {
            // console.log('+++++https://www.anastasis.it/supermappex-scuole');
            window.open('https://www.anastasis.it/smx-studio/#scuola', '_blank');
        }
    }

    public setSpellCheckerLanguages(lang: string, n: number = 0) {
        // GUI language
        const cookies = this.cookieService.getAll();
        const guiLangCookie = this.cookieService.get('GUILanguage');
        if (guiLangCookie) {
            (window as any).WEBSPELLCHECKER_CONFIG.localization = guiLangCookie;
        }
        // Spell checker language
        const MAX_RETRIES = 20;
        setTimeout(() => {
            const instances = (window as any).WEBSPELLCHECKER.getInstances();
            if (instances.length > 0) {
                console.log(`+++++WPR INSTANCE FOUND!!! (${n}) Lang=${lang}`);
                const inst = instances[0];
                const l = lang.replace('-', '_');
                inst.setLang(l);
            } else {
                if (n <= MAX_RETRIES) {
                    console.log(`-----NO WProofReader INSTANCES found (try #${n}) Lang=${lang}`);
                    this.setSpellCheckerLanguages(lang, n + 1);
                } else {
                    console.log(`-----MAX RETRIES EXCEEDED: NO WProofReader INSTANCES found`);
                }
            }
        }, 250);
    }

    public getInitials(fullname?: string) {
        let result = '';
        const userfullname = fullname || this.authenticationService.getUserFullname();
        if (userfullname && userfullname.trim() !== '') {
            userfullname.split(' ').forEach((name) => {
                result += (name && name.length > 0 ? name[0] : '');
            });
        }
        if (result.length === 0) {
            result = this.translateService.instant('SHARE_NONAME');
        } else if (result.length > 2) {
            result = result.substring(0, 2);
        }
        return result.toUpperCase();
    }

    async loadFonts(): Promise<void> {
        const fontFamilies = [
            'Architects Daughter',
            'IBM Plex Mono',
            'Montserrat',
            'Roboto',
            'Nunito',
            'Special Elite'
        ];
        const fontPromises = fontFamilies.map(font =>
            document.fonts.load(`1rem ${font}`)
        );
        await Promise.all(fontPromises);
        console.log('All fonts loaded!');
    }

    private sortLanguages() {
        if (!this.languages || this.languages.length == 0) return;
        this.languagesNoFlag = this.languages.filter(x => !x.icon || x.icon == UiConstants.FLAGS[0].icon);
        this.languagesWithFlag = this.languages.filter(x => x.icon && x.icon != UiConstants.FLAGS[0].icon);
    }

    // Messa anche qui per evitare errori di circular dependency
    public sendMessage(message: any) {
        (window as any).top.postMessage(message, "*");
    }
    public canDrop(type: string, ext?: string): boolean {
        if (ext && ext === 'doc') return false;
        let res = false;
        switch (type) {
            case 'application/pdf':
                res = true;
                break;

            case 'application/vnd.oasis.opendocument.text':
                res = true;
                break;
            case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
                res = true;
                break;
            case 'application/msword':
                res = true;
                break;
            case 'application/text/plain':
                res = true;
                break;


            case 'application/supermappex':
                res = true;
                break;
            case 'application/supermappe':
                res = true;
                break;
        }
        if (!res) {
            switch (ext) {
                case 'sme':
                    res = true;
                    break;
                case 'doc':
                    res = true;
                    break;
                case 'docx':
                    res = true;
                    break;
                case 'pdf':
                    res = true;
                    break;
            }
        }
        return res;
    }


}
